import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';
import { loadArchiveUsers } from '~src/services/api/tender';
import { DbTenderUser } from '~src/types/db';
import { useProjectId } from '../useProjectId';

export const useArchiveUsers = (
  queryConfig: QueryConfig<DbTenderUser[], AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const projectId = useProjectId();
  const { enabled, ...options } = queryConfig;

  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const archiveUsersQuery = useQuery<DbTenderUser[], AxiosError>(
    [
      'tenderArchiveList',
      {
        projectId: String(projectId),
      },
    ],
    loadArchiveUsers,
    {
      staleTime: 60 * 1000, // 1min
      enabled: enabledOverwrite && projectId,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return archiveUsersQuery.data;
};
